<template>
    <page :showDashboardButton="true">
        <!-- <template v-slot:header>
      <ion-title>Postbox</ion-title>
    </template> -->
        <ion-grid>
            <ion-row>
                <ion-col>
                    <h1 class="u-m-bottom-large">Postbox</h1>
                </ion-col>
                <ion-col class="ion-align-self-center ion-text-right">
                    <ion-button
                        fill="clear"
                        color="primary"
                        @click="openSettings()"
                    >
                        Einstellungen
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-segment
            @ionChange="segmentChanged($event)"
            class="ion-padding-bottom"
        >
            <ion-segment-button value="alle" checked>
                <ion-label>Alle</ion-label>
            </ion-segment-button>
            <ion-segment-button value="ungelesen">
                <ion-label>Ungelesen</ion-label>
            </ion-segment-button>
            <ion-segment-button value="gelesen">
                <ion-label>Gelesen</ion-label>
            </ion-segment-button>
        </ion-segment>
        <ion-card
            class="c-postbox-card"
            v-for="(message, key) in filteredPostbox"
            :target="'_blank'"
            :key="key"
            @click="
                downloadAndRead(
                    baseurl +
                        '/servlets/klickmal/api/?Mode=MeinServicebereich&Function=GetPostBoxFile&fileid=' +
                        key,
                    key
                )
            "
            button
        >
            <ion-grid>
                <ion-row class="ion-align-items-center">
                    <ion-col style="word-break: break-word;">
                        <div class="c-postbox-card__title">
                            <div
                                class="c-postbox-card__badge"
                                v-if="message.Status == 'UNREAD'"
                            ></div>
                            {{ message.Title }}
                        </div>
                        <div
                            v-if="getContractIdName(message.ContractId) !== ''"
                        >
                            <b>{{ getContractIdName(message.ContractId) }}</b>
                        </div>
                        <span
                            v-html="
                                allgemeinConfig(message.ContractId)
                                    .ContractIdFormatted || 'Vertragsnummer'
                            "
                        ></span
                        >: <b>{{ message.ContractIdFormatted }}</b>
                    </ion-col>
                    <ion-col size="auto" class="ion-text-right">
                        <div class="c-postbox-card__date">
                            {{
                                formatDate(
                                    message.CreationDate.substring(0, 10)
                                )
                            }}
                        </div>
                        <span class="icon-herunterladen u-size-large"></span>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <template
            v-if="
                Object.keys($store.state.postbox.all).length === 0 &&
                $store.state.loading
            "
        >
            <ion-card
                class="c-postbox-card"
                v-for="key in 5"
                :target="'_blank'"
                :key="key"
                button
            >
                <ion-grid>
                    <ion-row class="ion-align-items-center">
                        <ion-col>
                            <div class="c-postbox-card__title">
                                <ion-skeleton-text
                                    animated
                                    style="width: 30%;"
                                ></ion-skeleton-text>
                            </div>
                            <div>
                                <ion-skeleton-text
                                    animated
                                    style="width: 50%;"
                                ></ion-skeleton-text>
                            </div>
                        </ion-col>
                        <ion-col size="auto" class="ion-text-center">
                            <div class="c-postbox-card__date">
                                <ion-skeleton-text
                                    animated
                                    style="width: 50px;"
                                ></ion-skeleton-text>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card>
        </template>
        <p
            v-else-if="
                Object.keys(filteredPostbox).length === 0 &&
                !$store.state.loading
            "
        >
            Keine Nachrichten vorhanden
        </p>
    </page>
</template>

<script>
import Page from "@/components/Page";
import { getPostBoxFile } from "@/api/postbox";
import { BASEURL } from "@/utils/globals";
import { DateFormatter } from "@/utils/date";
import { Plugins } from "@capacitor/core";
import { file } from "@/mixins/file";
import PostboxSettingsModal from "@/components/PostboxSettingsModal";

export default {
    mixins: [file],
    components: { Page },
    data() {
        return {
            baseurl: BASEURL,
            api: process.env.VUE_APP_API,
            Browser: Plugins.Browser,
            selectedSegment: "alle",
        };
    },
    computed: {
        filteredPostbox() {
            let result = {};
            if (this.selectedSegment === "alle") {
                result = this.$store.state.postbox.all;
            } else if (this.selectedSegment === "ungelesen") {
                for (let key in this.$store.state.postbox.all) {
                    if (
                        this.$store.state.postbox.all[key].Status === "UNREAD"
                    ) {
                        result[key] = this.$store.state.postbox.all[key];
                    }
                }
            } else if (this.selectedSegment === "gelesen") {
                for (let key in this.$store.state.postbox.all) {
                    if (this.$store.state.postbox.all[key].Status === "READ") {
                        result[key] = this.$store.state.postbox.all[key];
                    }
                }
            }
            return result;
        },
    },
    mounted() {
        this.$store.dispatch("postbox/getPostBoxEntries");
    },
    methods: {
        segmentChanged(e) {
            this.selectedSegment = e.detail.value;
        },
        getContractIdName(contractId) {
            let result = "";
            if (contractId in this.$store.state.contracts) {
                result = this.$store.state.contracts[contractId].Name;
            }
            return result;
        },
        getFile(fileid) {
            getPostBoxFile(fileid);
        },
        formatDate(dateString) {
            return DateFormatter.formatDate(
                new Date(dateString),
                "DD. MMM YYYY"
            );
        },
        allgemeinConfig(contractId) {
            let result = {};

            if (this.$store.state.contracts[contractId]) {
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[contractId].Sparte
                ].allgemein;
            }

            return result;
        },
        downloadAndRead(url, key) {
            this.downloadFile(url);
            let postBoxEntry = { ...this.$store.state.postbox.all[key] };
            postBoxEntry.Key = key;
            postBoxEntry.Status = "READ";
            this.$store.commit("postbox/setPostBoxEntry", postBoxEntry);
        },
        openSettings() {
            this.$ionic.modalController
                .create({
                    component: PostboxSettingsModal,
                    componentProps: {
                        propsData: {},
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
    },
};
</script>

<style lang="scss" scoped>
.c-postbox-card {
    &__title {
        font-size: large;
        font-weight: bold;
        margin-bottom: var(--gangl-padding-small);
    }
    &__date {
        margin-bottom: var(--gangl-padding-small);
    }

    .c-postbox-card__badge {
        margin-right: 10px;
        display: inline-block;
        background: var(--ion-color-primary);
        border-radius: 40px;
        // padding: 2px 10px 5px 10px;
        width: 10px;
        height: 10px;
        color: var(--ion-color-primary-contrast);
        font-size: 11px;
        line-height: 2;
        // right: calc(var(--ion-safe-area-right, 0px) - 10px);
    }
}
ion-datetime {
    --padding-start: 0;
    --padding-top: 0;
    --padding-bottom: 0;
}
</style>
